export function parseDuration(durationString) {
    if (!durationString) {
        return null;
    }
    // Regex matching an ISO 8601 duration format
    // Where the first group matches the year, the second group matches the months, the third group matches the days
    // The fourth group matches the hours, the fifth group matches the minutes and the last group matches the seconds
    // Example of duration: P0Y0M0DT0H0M1997.260S
    var re = '^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$';
    var matches = new RegExp(re).exec(durationString);
    if (!matches) {
        return null;
    }
    // Note: Number(null) == 0 but Number(undefined) == NaN.
    var years = Number(matches[1] || null);
    var months = Number(matches[2] || null);
    var days = Number(matches[3] || null);
    var hours = Number(matches[4] || null);
    var minutes = Number(matches[5] || null);
    var seconds = Number(matches[6] || null);
    // Assume a year always has 365 days and a month always has 30 days.
    var d = 60 * 60 * 24 * 365 * years + 60 * 60 * 24 * 30 * months + 60 * 60 * 24 * days + 60 * 60 * hours + 60 * minutes + seconds;
    return isFinite(d) ? d : null;
}
export function trimBeginningOfContent(content) {
    if (content) {
        var index = content.indexOf('<?xml');
        if (index > -1) {
            content = content.substring(index);
        }
    }
    return content;
}
export function decodeXmlEntities(text) {
    var entities = [
        [
            /&lt;/g,
            '<'
        ],
        [
            /&gt;/g,
            '>'
        ],
        [
            /&quot;/g,
            '"'
        ],
        [
            /&apos;/g,
            "'"
        ],
        [
            /&amp;/g,
            '&'
        ]
    ];
    if (!text) {
        return '';
    }
    return entities.reduce(function(acc, cur) {
        return acc.replace(cur[0], cur[1]);
    }, text);
}

//# sourceMappingURL=xml-utils.js.map